<template>
    <div class="header">
        <LoginBox :isShowFormBox="showLoginBox" @showPwReset="_showPwResetBox" @closeLogin="_closeLoginBox"
            @loginSuccess="_loginSuccess" />
        <PwResetBox :isShowPwResetBox="showPwResetBox" @closePwReset="_closePwResetBox"
            @swicthToLoginForm="_swicthToLoginForm" />
        <div class="nav_bar">
            <div class="logo">
                <a href="./home.html">
                    <img src="../assets/2022/yingshiwang_b.png" alt="Logo">
                </a>
            </div>
            <div class="nav_box">
                <a href="./home.html" :class="{ active: curTab === 1 }" data-role="1">首页</a>
                <a href="./morescriptlist.html" :class="{ active: curTab === 2 }" data-role="2">剧本专区</a>
                <a href="./school.html" :class="{ active: curTab === 3 }" data-role="3">北门学院</a>
                <a href="./producer.html" :class="{ active: curTab === 4 }" data-role="4"
                    v-if="!loginSuc && is_plan">项目专区</a>
            </div>
            <div class="upload-box">
                <button class="upload-btn" @click="toUploadPage"><img src="../assets/2021/upload-icon.png"
                        alt=""><span>上传</span></button>
            </div>
            <div class="login_box">
                <p class="login_item" v-if="loginSuc">
                    <button @click="toLoginPage" class="login-btn"><img src="../assets/2021/login-icon.png"
                            alt=""><span>登录<span class="column-line">/</span>注册</span></button>
                </p>
                <div class="login_suc" v-if="!loginSuc">
                    <a href="./usercenter.html" class="user-icon-link" style="vertical-align:top;"
                        @mouseenter.stop="showLoginSucSel" @mouseleave.stop="hideLoginSucSel"><span
                            class="user-icon-box"><img :src="userIcon" v-show="userIcon"></span></a>
                    <span class="msg-sign" v-if="messageUnread != 0"></span>
                    <div class="user_phone_num" style="vertical-align:top;" @mouseenter.stop="showLoginSucSel"
                        @mouseleave.stop="hideLoginSucSel">
                        <div class="login_suc_sel" v-show="!loginSucSelShow" ref="loginSucSel" @mouseenter="loginSucIn"
                            @mouseleave="loginSucOut">
                            <div class="user-brief-info">
                                <div class="avatar">
                                    <img :src="userIcon" v-show="userIcon">
                                </div>
                                <div class="info">
                                    <div class="name-authen">
                                        <div class="name">
                                            <span class="name-box" :title="userName">{{ userName }}</span><img
                                                v-if="users.white_info && users.white_info.is_vip"
                                                src="../assets/correcting-img/vip.png" alt="">
                                        </div>
                                        <div class="authen">
                                            <span class="done" v-if="userInfo.real_name_auth">已认证</span><span
                                                class="not" v-if="!userInfo.real_name_auth">未认证</span>
                                        </div>
                                    </div>
                                    <p class="exchange-info" v-if="userInfo.white_info && userInfo.white_info.date">
                                        {{ userInfo.white_info && userInfo.white_info.type }}有效期至{{ userInfo.white_info
                                                && userInfo.white_info.date.substring(0, 10)
                                        }}
                                    </p>
                                </div>
                            </div>
                            <div class="link-box">
                                <div class="line-item"><img src="../assets/correcting-img/usercenter.png" alt="">
                                    <div class="link-list"><a href="./usercenter.html">个人中心</a><span
                                            v-if="messageUnread != 0"></span></div>
                                </div>
                                <div class="line-item"><img src="../assets/correcting-img/security.png" alt="">
                                    <div class="link-list"><a href="./safecenter.html">安全中心</a></div>
                                </div>
                                <div class="line-item"><img src="../assets/correcting-img/logout.png" alt="">
                                    <div class="link-list" @click="logout" style="cursor:pointer"><a>退出</a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from '@/store'
import Axios from '@/api/Axios'
import axios from 'axios'
import LoginBox from '@/components/LoginBox'
import PwResetBox from '@/components/PwResetBox'
import { mapActions, mapGetters } from 'vuex'
import { GetCookie, DelCookie, SetCookie } from '@/api/cookie'
import { getParams } from '@/api/getUrlParams'
// import { message } from '@/api/resetMsg';
export default {
    name: 'HomeHeaderNav',
    props: ['curTab', 'changeAvatar'],
    store,
    data() {
        return {
            userInfo: '',                  //储存用户信息
            userName: '',                  //储存用户名
            loginSuc: true,                //登陆成功后一场登陆注册按钮显示用户头像和用户名div
            loginSucSelShow: true,         //鼠标移入用户名后显示个人中心安全中心下拉框
            getTokenCookie: '',            //储存缓存里的TOKEN判断是否已登陆
            userIcon: '',                  //用户头像图片
            timer: '',                     //个人中心安全中心下拉菜单滑鼠事件
            is_plan: '',                   //判断是否有进入项目专区权限
            showLoginBox: '',              //控制登录弹窗显示隐藏
            showPwResetBox: '',            //作为中间变量储存登陆弹窗点击忘记密码传来的值再给忘记密码组件传值
            changeCurTab: false,           //作品上传点击active状态
            hideTimer: '',                 //作品上传入口显示时间
            redBorder: false,              //作品上传选项下边框样式
            pwResetReload: ''              //修改密码页面重新加载
        }
    },
    created() {
        //根据URL中是否有KEY值判断用户是否使用三方登陆
        //如果有KEY的话则是通过三方登陆登录 用KEY值请求接口获取用户信息
        if (getParams('key')) {
            Axios.get('thirdlogin/' + getParams('key')).then(
                response => {
                    if (response.data.code == 201) {
                        //如果通过三方登陆URL中有KEY则在取回数据时为导航头像和用户名赋值
                        this.userIcon = response.data.data.icon
                        this.userName = response.data.data.name
                        this.loginSuc = false
                        SetCookie('token', response.data.data.token)
                        SetCookie('phone', response.data.data.phone)
                        SetCookie('real_auth', response.data.data.real_name_auth)
                        SetCookie('v', response.data.data.white_info.is_vip)
                        this.getTokenCookie = GetCookie('token')
                        let url = window.location.href
                        let valiable = url.split("?")[0]
                        window.history.pushState({}, 0, valiable)
                    }
                },
                error => {
                    console.log(error)
                    this.$message.error({
                        message: '获取个人信息失败 请刷新重试',
                        type: 'error',
                        center: true,
                        offset: 100,
                        duration: 900
                    });
                }
            )
        }
        //刷新页面后从缓存读取用户名和用户头像和未读消息
        if (GetCookie('token')) {
            this.readUnreadMessage()
            this.readUsers()
        }
        GetCookie('token') ? this.loginSuc = false : this.loginSuc = true
    },
    mounted() {
        if (GetCookie('PWRT')) {
            this.showLoginBox = true
            DelCookie('PWRT')
        }
        if (GetCookie('PRT')) {
            this.showLoginBox = true
            DelCookie('PRT')
        }
    },
    computed: {
        ...mapGetters(['users', 'messageUnread'])
    },
    watch: {
        'getTokenCookie': function (val) {
            val ? this.loginSuc = false : this.loginSuc = true
        },
        'users': function (val) {
            this.userInfo = val
            this.userName = val.name
            this.is_plan = val.is_plan
            this.userIcon = val.icon
        },
        'changeAvatar': function (val) {
            this.userIcon = val
        },
    },
    methods: {
        ...mapActions(['readUsers', 'readUnreadMessage']),
        //跳转上传页权限判断
        toUploadPage() {
            if (!GetCookie('token')) {
                this.$message.error({
                    message: '未登录 不能进行此操作',
                    type: 'error',
                    center: true,
                    offset: 100,
                    duration: 900
                })
                return false
            } else {
                window.open("/uploadscript.html", "_blank")
            }
        },
        //点击登录弹出登录对话框
        toLoginPage() {
            this.showLoginBox = true
        },
        //关闭登录对话框
        _closeLoginBox(val) {
            this.showLoginBox = val
        },
        //监听登陆对话框中的点击忘记密码事件 切换到忘记密码弹窗
        _showPwResetBox(val) {
            this.showPwResetBox = val
        },
        //关闭忘记密码表单弹窗
        _closePwResetBox(val) {
            this.showPwResetBox = val
        },
        //收到Login组件登陆成功状态后改变上导航登陆状态
        _loginSuccess(val) {
            if (val) {
                setTimeout(() => {
                    window.location.reload()
                }, 400)
            }
        },
        //监听忘记密码表单弹窗中点击返回登陆按钮事件 切换回登陆表单
        _swicthToLoginForm() {
            this.showLoginBox = true
            this.showPwResetBox = false
        },
        showLoginSucSel() {
            clearInterval(this.timer)
            this.loginSucSelShow = false;
        },
        hideLoginSucSel() {
            this.timer = setTimeout(() => {
                this.loginSucSelShow = true;
            }, 600)
        },
        loginSucIn() {
            clearInterval(this.timer)
            this.loginSucSelShow = false;
        },
        loginSucOut() {
            this.loginSucSelShow = true;
        },
        logout() {
            axios({
                method: 'post',
                url: 'https://admin.beimen.com/api/v1/logout',
                headers: {
                    'Authorization': GetCookie('token')
                }
            }).then(
                response => {
                    if (response.data.code == 200 && response.data.status == "success") {
                        this.loginSuc = true
                        DelCookie("token")
                        DelCookie("real_auth")
                        DelCookie("v")
                        DelCookie("name")
                        DelCookie("icon")
                        setTimeout(function () { location.href = '/home.html' }, 300)
                    }
                },
                error => {
                    console.log(error)
                    this.$message.error({
                        message: '网络错误   请稍后再试',
                        type: 'error',
                        center: true,
                        offset: 100,
                        duration: 900
                    });
                }
            );
        }
    },
    components: {
        LoginBox,
        PwResetBox
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.active {
    color: #fff !important;
    font-weight: bold !important;
}

.header {
    width: 100%;
    height: 0.8rem;
    margin: 0.3rem 0 0.2rem 0;
}

.login_suc_sel {
    width: 3.50rem;
    height: 2.70rem;
    position: absolute;
    z-index: 999999;
    text-align: center;
    background: #fff;
    top: 0.64rem;
    left: -3rem;
    border-radius: 0px 0px 2px 2px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);

    .user-brief-info {
        width: 3.50rem;
        height: 1rem;
        padding: 0.2rem;
        background: #f7f7f7;

        .avatar {
            width: 0.50rem;
            height: 0.50rem;
            border-radius: 50%;
            float: left;
            margin-right: 0.15rem;

            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }

        .info {
            width: 2.45rem;
            float: left;

            .name-authen {
                font-size: 0.18rem;
                color: #222;
                font-weight: bold;
                display: flex;
                display: -webkit-flex;
                justify-content: space-between;

                .name {
                    .name-box {
                        width: 1.34rem;
                        display: -webkit-box;
                        -webkit-line-clamp: 1;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    span,
                    img {
                        float: left;
                    }

                    img {
                        width: 0.32rem;
                        height: 0.28rem;
                        transform: translateY(0.07rem);
                    }
                }

                .authen {
                    span {
                        width: 0.55rem;
                        height: 0.22rem;
                        line-height: 0.22rem;
                        text-align: center;
                        font-size: 0.14rem;
                        border-radius: 0.2rem;
                        padding: 0.02rem 0.1rem;
                    }

                    .done {
                        background: #BF0000;
                        color: #fff;
                    }

                    .not {
                        color: #999;
                        background: #E6E6E6;
                    }
                }
            }

            .exchange-info {
                font-size: 0.14rem;
                color: #999;
                text-align: left;
                letter-spacing: 2px;
            }
        }
    }

    .link-box {
        height: 1.70rem;
        width: 3.50rem;
        padding-left: 0.90rem;
    }

    .line-item {
        display: -webkit-flex;
        display: flex;
        align-items: center;
        width: 100%;

        img {
            width: 0.14rem;
            height: 0.18rem;
            margin-right: 0.1rem;
        }
    }

    .link-list {
        text-align: left;
        width: 2.3rem;
        border-bottom: 1px solid #e6e6e6;
        padding: 0.07rem 0;
        position: relative;

        a {
            text-decoration: none;
            font-size: 0.18rem;
            text-align: center;
            color: #222;
            letter-spacing: 2px;
            vertical-align: top;
        }

        span {
            display: inline-block;
            width: 0.1rem;
            height: 0.1rem;
            border-radius: 50%;
            background: #BF0000;
            position: absolute;
            left: 0.8rem;
            top: 0.12rem;
        }
    }

    .line-item:last-child .link-list {
        border-bottom: none;
    }

    .line-item:hover {
        a {
            color: #BF0000;
        }
    }
}

.nav_bar {
    width: 16.96rem;
    height: 0.8rem;
    line-height: 0.8rem;
    padding: 0.1rem 0;
    margin: 0 auto;
    position: relative;
    z-index: 10;

    .logo,
    .nav_box,
    .upload-box,
    .login_box {
        position: absolute;
    }
}

.logo {
    width: 297px;
    height: 47px;
    // width: 1.56rem;
    // height: 0.47rem;
    left: 0;
    top: 50%;
    transform: translateY(-50%);

    img {
        width: 100%;
        height: 100%;
        vertical-align: top;
    }
}

.nav_box {
    height: 0.60rem;
    padding: 0 0.36rem;
    line-height: 0.6rem;
    // left: 2.18rem;
    left: 307px;

    a {
        display: inline-block;
        padding: 0 0.2rem;
        text-decoration: none;
        color: #FEFEFE;
        font-size: 18px;
        font-weight: 400;
        vertical-align: top;
    }

    a:hover {
        opacity: 0.7;
    }
}

.upload-box {
    right: 2.20rem;
    top: 50%;
    height: 0.4rem;
    line-height: 0.4rem;
    transform: translateY(-0.12rem);

    .upload-btn {
        background: none;
        outline: none;
        border: none;
        color: #FEFEFE;
        font-size: 0.18rem;
        cursor: pointer;
        vertical-align: top;

        img,
        span {
            vertical-align: middle;
        }

        img {
            margin-right: 0.1rem;
            width: 0.18rem;
            height: 0.18rem;
        }
    }
}

.login_box {
    height: 0.40rem;
    line-height: 0.40rem;
    color: #fff;
    right: 0;
    //width:1.70rem;
    text-align: right;
    top: 50%;
    vertical-align: top;
    transform: translateY(-0.20rem);

    .login_item {
        //width:1.70rem;
        height: 0.40rem;
        display: inline-block;

        .login-btn {
            display: inline-block;
            height: 0.40rem;
            line-height: 0.4rem;
            background: none;
            outline: none;
            border: none;
            padding: 0 0.2rem;
            text-decoration: none;
            color: #FEFEFE;
            font-size: 0.18rem;
            font-weight: 500;
            text-align: center;
            vertical-align: top;
            cursor: pointer;

            img {
                width: 0.18rem;
                height: 0.18rem;
                margin-right: 0.1rem;
                vertical-align: middle;
            }

            span {
                display: inline-block;
                transform: translateY(2px);
            }

            .column-line {
                padding: 0 0.1rem;
            }
        }

        .login-btn:hover {
            background: rgba(0, 0, 0, .7)
        }
    }

    .login_suc {
        width: 0.4rem;
        height: 0.4rem;
        line-height: 0.4rem;
        position: absolute;
        right: 1.2rem;
        z-index: 9999;

        .user-icon-link {
            display: inline-block;
            width: 0.4rem;
            height: 0.4rem;
        }

        .msg-sign {
            display: inline-block;
            position: absolute;
            width: 0.10rem;
            height: 0.10rem;
            border-radius: 50%;
            background: #bf0000;
            left: 0.34rem;
            top: 0;
        }

        .user-icon-box {
            display: inline-block;
            width: 0.4rem;
            height: 0.4rem;
            border-radius: 50%;

            img {
                height: 0.4rem;
                width: 0.4rem;
                border-radius: 50%;
                vertical-align: top;
            }
        }
    }
}

.header-register {
    display: inline-block;
    width: 0.84rem;
    height: 0.34rem;
    text-align: center;
    line-height: 0.34rem;
    border: 1px solid #FAFAFA;
    background: #535353;
    border-radius: 30px;
    color: #FEFEFE;
}
</style>
